











































import Vue from 'vue'
import ItemCard from './ItemCard.vue'
import { Project } from '@/model/Project'

export default Vue.extend({
  name: 'ProjectList',
  components: {
    ItemCard,
  },
  props: {
    showBookmarkAction: {
      type: Boolean,
      default: true,
    },
    showEditProjectIcon: {
      type: Boolean,
      default: false,
    },
    actionBaseName: {
      type: String,
    },
    orderDirection: {
      type: String,
    },
    filters: {
      type: Object,
    },
    removeFavourites: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.loadProjects()
  },
  data: () => ({
    items: [] as Project[],
    itemsPerPage: 16,
    currentPage: 1,
    totalPages: 1,
    loadNextPageLoading: false,
  }),
  methods: {
    requestParameters: function () {
      const params: any = {
        itemsPerPage: this.itemsPerPage,
        page: this.currentPage,
        'order[createdAt]': this.orderDirection,
      }

      if (this.filters.category && this.filters.category.slug) {
        params['categories.slug'] = this.filters.category.slug
      }

      if (this.filters.contest && this.filters.contest['@id']) {
        params['contestApplications.contest'] = this.filters.contest['@id']
        params['contestApplications.status'] = "accept"
      }

      if (this.filters.tags && this.filters.tags.length) {
        for (let i = 0; i < this.filters.tags.length; i++) {
          params['tags.name[' + i + ']'] = this.filters.tags[i]
        }
      }

      return params
    },
    loadProjects: function () {
      this.currentPage = 1
      this.$api
        .get(this.actionBaseName, { params: this.requestParameters() })
        .then((response) => {
          this.items = response.data['hydra:member']
          this.totalPages = Math.ceil(
            response.data['hydra:totalItems'] / this.itemsPerPage
          )
        })
    },
    loadNextPage: function () {
      this.loadNextPageLoading = true
      const requestParameters = this.requestParameters()
      requestParameters.page++
      this.$api
        .get(this.actionBaseName, { params: requestParameters })
        .then((response) => {
          this.items = [...this.items, ...response.data['hydra:member']]
          this.currentPage++
          if (this.currentPage === this.totalPages) {
            this.$store.dispatch(
              'alert/info',
              'You have seen all projects already!'
            )
          }
        })
        .finally(() => (this.loadNextPageLoading = false))
    },
    bookmarkRemoved: function (projectItem: Project) {
      if (this.removeFavourites) {
        this.items.splice(this.items.indexOf(projectItem), 1)
      }
    },
  },
  watch: {
    orderDirection: function () {
      this.loadProjects()
    },
    filters: function () {
      this.loadProjects()
    },
  },
})
